module.exports = __webpack_public_path__ + "assets/img/me_banner.e38a1dcc.png";